import { Link } from "gatsby";
import * as React from "react";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import DoNotMountComponent from "../../modules/DoNotMountComponent/DoNotMountComponent";
import { ILink } from "../../types/thecookies";
import { cleanAfterBreakLine } from "../shared/utils/createTitle";

type PropsBreadcrumbs = PropsWithChildren<{
  data: ILink[];
}>;

const Breadcrumbs: React.FC<PropsBreadcrumbs> = (props: PropsBreadcrumbs) => {
  if (!props.data) return <DoNotMountComponent sms={"Breadcrumbs"} log={props} />;
  const { t } = useTranslation("global");
  const { length } = props.data;
  return (
    <nav className={`m-breadcrumbs`}>
      <ul className={"breadcrumbs__list"}>
        {props.data.map((link, index) => (
          <li className={"breadcrumbs__item"} key={index}>
            {index !== length - 1 ? (
              <Link to={`${link?.slug}`}>{cleanAfterBreakLine(link.name)}</Link>
            ) : (
              cleanAfterBreakLine(link.name)
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Breadcrumbs;
